import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { API } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const email = localStorage.getItem("pending_email");
          const r = await axios.post(`${API}/access/verify`, { email });
          localStorage.setItem("vault_token", r.data.token);
          setState("paid");
          timer = setTimeout(() => navigate("/vault"), 1800);
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) { /* keep polling */ }
      if (++tries >= 15) return setState("failed");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, navigate]);

  return (
    <div className="min-h-screen grid place-items-center px-6 relative z-10">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        {state === "checking" && <><Loader2 className="mx-auto animate-spin text-emerald-400" size={40} /><h1 className="font-display text-2xl mt-6" data-testid="payment-status-checking">Confirming your payment…</h1></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto text-emerald-400" size={48} /><h1 className="font-display text-3xl mt-6" data-testid="payment-status-paid">You're in.</h1><p className="text-slate-400 mt-2">Opening your vault…</p></>}
        {state === "failed" && <><XCircle className="mx-auto text-red-400" size={48} /><h1 className="font-display text-2xl mt-6" data-testid="payment-status-failed">We couldn't confirm the payment</h1><p className="text-slate-400 mt-2">If you were charged, use "Restore access" with your email.</p><Link to="/" className="inline-block mt-6 text-emerald-400" data-testid="payment-back-home">Back to home</Link></>}
      </div>
    </div>
  );
}
